import { client, deaxiosify } from '#api/common';
import type { LocatedPhoneProps } from '#types/Geo.ts';

export const getPhoneData = async (number: string) => {
  return await client
    .get<LocatedPhoneProps>(`/visit/phone-data?phone=${encodeURIComponent(number)}`)
    .then(deaxiosify);
};
